export default __webpack_public_path__ + "static/media/logos_Kunden_neu.a55d27cb.png";